import { classnames } from 'tailwindcss-classnames';

export const hasSubmenu = classnames('border-b', 'border-gray-whisper', 'has-submenu', 'relative');
export const animateNavOpen = classnames('translate-x-0', 'left-0');
export const animateNavClose = classnames('-translate-x-full', 'left-[-100%]');
export const utilityLinkClass = classnames(
  'block',
  'leading-3',
  'hover:underline',
  'text-blue-navy'
);
export const mobileMainNav = classnames(
  'absolute',
  'bg-white',
  'transition-transform',
  'w-full',
  'z-30',
  'pb-12'
);
export const toggleButton = classnames(
  'bg-white',
  'flex',
  'flex-row',
  'float-right',
  'h-auto',
  'mx-2',
  'relative',
  'z-20',
  'mt-3'
);
